import { enums } from 'console-kit';

import { createActionFactory } from '../../common/redux';

const { createAction } = createActionFactory('Console => ');

const dismissApiError = createAction('dismiss API error');

const setAlertMessage = createAction('set alert message', ({ messageType, header, byline, timeout }) => ({
  messageType,
  header,
  byline,
  timeout,
}));
const dismissAlertMessage = createAction('dismiss alert message');

const validateForm = createAction(
  'validate form',
  ({
    formId,
    messageType = enums.messageTypes.WARNING,
    header = 'The form has invalid fields.',
    onValid, //callback to be called when the form is valid
    onInvalid, //callback to be called when the form is invalid
  }) => ({
    formId,
    messageType,
    header,
    onValid,
    onInvalid,
  })
);

export default { dismissApiError, setAlertMessage, dismissAlertMessage, validateForm };
